<template>
  <div id="contenedor-listado-documentos-relacionados-mobile"></div>
</template>

<script>
export default {
  name: 'ListadoDocumentosRelacionados',
  props: {
    listadoDocumentosRelacionados: {
      type: Array,
      required: true,
    },
  },

};
</script>

<style>

</style>
